module.exports = __webpack_public_path__ + "img/smb-key-keeper-old-black.256.a7f19e87.png";